<script lang="ts">
	import Introduction from "./Introduction.svelte";
  import Orthogone from "./Orthogone.svelte";
  import MuranoFantasy from "./MuranoFantasy.svelte";
  import Reverie from "./Reverie.svelte";
  import AboutAuthor from "../common/AboutAuthor.svelte";
  import Genuary from "./Genuary.svelte";
  import DashboardDyslexia from "./DashboardDyslexia.svelte";
</script>

<main class="container">

  <section>
		<Introduction />    
	</section>

  <section>
    <Reverie />
  </section>

  <section>
    <DashboardDyslexia />
  </section>

  <section>
    <Genuary />
  </section>

  <section>
    <MuranoFantasy />
  </section>

  <section>
    <Orthogone />
	</section>

	<section>
		<div><AboutAuthor /></div>
	</section>


  <footer>
    <span id="copyright"
      >&copy; Copyright 2024, Pandelune. All the content is under copyright.</span
    >
  </footer>

</main>
